import React from 'react';
import {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import { io } from "socket.io-client";

import './App.css';
import './output.css';
import sharedVariable from './global_v';

const env1 = 'development';
const env2 = 'production';

var env = env2;

const currentURL = window.location.href;
if (!currentURL.includes('localhost')){
  env = 'production';
}

var user_info = [];
var current_page = 0;

// 防止频繁refresh
var last_refresh_time = 0;

function Analyse_user_info(temp_user_info){
  if (temp_user_info.index === 1){
    return(
      <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
        <div style={{width:'50%'}} className='flex'>
          <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
            <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#FFD700'}} className='relative grid place-content-center'>
              <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                <div style={{right:'0.05rem', top:'0.1rem', color:'#FFD700'}} className='relative'>
                  {temp_user_info.index}
                </div>  
              </div> 
            </div>
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
            uid:{temp_user_info.uid}
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
            昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
          </div>          
        </div>
        <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
          累计获得的钻石数量:{temp_user_info.get_diamond_amount}
        </div>        
      </div>
    )
  }
  if (temp_user_info.index === 2){
    return(
      <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
        <div style={{width:'50%'}} className='flex'>
          <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
            <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#c0c0c0'}} className='relative grid place-content-center'>
              <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                <div style={{right:'0.05rem', top:'0.1rem', color:'#c0c0c0'}} className='relative'>
                  {temp_user_info.index}
                </div>  
              </div> 
            </div>
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
            uid:{temp_user_info.uid}
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
            昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
          </div> 
        </div>
        <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
          累计获得的钻石数量:{temp_user_info.get_diamond_amount}
        </div>        
      </div>
    )    
  }
  if (temp_user_info.index === 3){ 
    return(
      <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
        <div style={{width:'50%'}} className='flex'>
          <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
            <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#D98719'}} className='relative grid place-content-center'>
              <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                <div style={{right:'0.05rem', top:'0.1rem', color:'#D98719'}} className='relative'>
                  {temp_user_info.index}
                </div>  
              </div> 
            </div>
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
            uid:{temp_user_info.uid}
          </div>
          <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
            昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
          </div> 
        </div>
        <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
          累计获得的钻石数量:{temp_user_info.get_diamond_amount}
        </div>        
      </div>   
    )
  }
  if (temp_user_info.index > 3){
    if (temp_user_info.index % 2 === 0){
      if (temp_user_info.index < 10){
        return(
          <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
            <div style={{width:'50%'}} className='flex'>
              <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
                <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                  <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                    <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                      {temp_user_info.index}
                    </div>  
                  </div> 
                </div>
              </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
              uid:{temp_user_info.uid}
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
              昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
            </div> 
            </div>
            <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
              累计获得的钻石数量:{temp_user_info.get_diamond_amount}
            </div>        
          </div>   
        )
      }
      else{
        return(
          <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
            <div style={{width:'50%'}} className='flex'>
              <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
                <div style={{top:'0.5rem', width:'2.5rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                  <div style={{width:'2rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                    <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                      {temp_user_info.index}
                    </div>  
                  </div> 
                </div>
              </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
              uid:{temp_user_info.uid}
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
              昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
            </div> 
            </div>
            <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
              累计获得的钻石数量:{temp_user_info.get_diamond_amount}
            </div>        
          </div>   
        )        
      }
    }
    else{
      if (temp_user_info.index < 10){
        return(
          <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
            <div style={{width:'50%'}} className='flex'>
              <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
                <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                  <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                    <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                      {temp_user_info.index}
                    </div>  
                  </div> 
                </div>
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                uid:{temp_user_info.uid}
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
              </div> 
            </div>
            <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
              累计获得的钻石数量:{temp_user_info.get_diamond_amount}
            </div>        
          </div>   
        )
      }
      else{
        return(
          <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
            <div style={{width:'50%'}} className='flex'>
              <div style={{marginLeft:'5rem', width:'3rem', height:'2rem'}} className='relative'>
                <div style={{top:'0.5rem', width:'2.5rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                  <div style={{width:'2rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                    <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                      {temp_user_info.index}
                    </div>  
                  </div> 
                </div>
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                uid:{temp_user_info.uid}
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
              </div> 
            </div>
            <div style={{marginLeft:'10rem', marginTop:'0.5rem'}}>
              累计获得的钻石数量:{temp_user_info.get_diamond_amount}
            </div>        
          </div>   
        )        
      }
    }
  }
}

const Rank = () => {
  const temp_count = useRef(0);

  const [changeClass, setChangeClass] = useState(false);
  const [page, set_page] = useState(current_page);

  const navigate = useNavigate();

  if (temp_count.current === 0){
    temp_count.current = 1;

    if (sharedVariable.login_status){
      var socket;
  
      if (env === 'development'){
        socket = io.connect('http://localhost:5001',{
          path:"/socket.io/"
        });
      }
      else{
        socket = io.connect('https://bailanjo.cn',{
          path:"/socket.io/"
        });
      }     

      socket.emit('get_rank_list', 1);

      socket.once('get_rank_list_result', function(msg){
        if (msg[0].status === 'succeed'){
          user_info = [];
          var temp_index = 1;

          msg[0].data.forEach(temp_user_info => {
            if (temp_user_info.get_diamond_amount > 0){
              var temp_uid = temp_user_info.uid.toString();

              var temp_length = temp_user_info.uid.toString().length;
              if (temp_length <= 8){
                for(let i = 0;i < 8 - temp_length; i++){
                  temp_uid = '0' + temp_uid;
                }
              }

              user_info.push({'index':temp_index, 'uid':temp_uid, 'nickname':temp_user_info.nickname, 'get_diamond_amount':temp_user_info.get_diamond_amount})

              temp_index += 1;                
            }
          });

        }
        else{
          alert('查看排行榜失败！')
        }

        set_page(0);

        setTimeout(() => {
          setChangeClass(true);
        }, 100);

        socket.disconnect();
      });
    }
    else{
      alert('请登录后再查看排行榜！')
    }      
  }

  function refresh(){
    if (Math.floor(new Date().getTime() / 1000) - last_refresh_time > 1){
      last_refresh_time = Math.floor(new Date().getTime() / 1000);

      navigate('/blank');
      setTimeout(() => {
        navigate('/rank');
      }, 10);    
    }           
    else{
      alert('刷新过于频繁！');
    }  
  }

  function change_page1(){
    current_page -= 1;
    if (current_page < 0){
      if (user_info.length % 10 === 0){
        current_page = user_info.length / 10 - 1;
      }
      else{
        current_page = Math.ceil(user_info.length / 10) - 1;
      }
    }
    set_page(current_page); 
  }

  function change_page2(){
    current_page += 1;
    if (user_info.length % 10 === 0){
      if (current_page > user_info.length / 10 - 1){
        current_page = 0;
      }
    }
    else{
      if (current_page > Math.ceil(user_info.length / 10 - 1)){
        current_page = 0;
      }
    }
    set_page(current_page);
  }

  return(
    <div style={{height:'calc(100lvh - 4rem)', minWidth:'70rem'}} className="z-10 w-full bg-amber-50">
      <div style={{transition:'opacity 1s ease', whiteSpace:'pre-wrap', fontFamily:'hello headline, lyt'}} className={!changeClass ? "opacity-0" : "opacity-100"}>
        <div className='flex'>
          <div onClick={refresh} style={{left:'5rem', top:'2rem', cursor:'pointer'}} className='relative'>
            <div style={{width:'6rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
              <div style={{width:'5.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                <div style={{marginRight:'0.1rem', fontSize:'1.2rem'}}>
                  刷新
                </div>
              </div>
            </div>
          </div>                  
          <div onClick={change_page1} style={{left:'7rem', top:'2rem', cursor:'pointer'}} className='relative'>
            <div style={{width:'3rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
              <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                <div style={{marginRight:'0.125rem', fontSize:'1.75rem'}}>
                  {"<"}
                </div>
              </div>
            </div>
          </div>
          <div onClick={change_page2} style={{left:'9rem', top:'2rem', cursor:'pointer'}} className='relative'>
            <div style={{width:'3rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
              <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                <div style={{marginLeft:'0.125rem', fontSize:'1.75rem'}}>
                  {">"}
                </div>
              </div>
            </div>
          </div> 
          <div style={{top:'2rem', left:'calc(50% - 27rem)', fontSize:'36px', width:'30rem'}} className='relative text-center'>
              排行榜
          </div>
        </div>
        <div style={{marginTop:'2rem', minHeight:'calc(100lvh - 9.5rem)'}} className='bg-amber-100'>
          {
            user_info.map((temp_user_info) => {
              if (temp_user_info.index - 1 >= page * 10 && temp_user_info.index - 1 < (page + 1) * 10){
                return(
                  <div style={{fontSize:'24px'}} key={Math.random().toString(36).substring(2, 9)}>
                    {Analyse_user_info(temp_user_info)}
                  </div>  
                )
              }
            }) 
          }
        </div>
      </div>
    </div> 
  )
};

export default Rank;